<template>
  <div class="empresas-page">
    <PageHeader 
      title="Gerenciamento de Empresas"
      :show-back-button="true"
      @back="voltar"
    />

    <main class="main-container">
      <!-- Barra de ações -->
      <div class="action-bar">
        <div class="search-wrapper">
          <svg class="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16zM19 19l-4.35-4.35" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <input
            type="text"
            v-model="filtro"
            class="search-input"
            placeholder="Pesquisar empresas..."
          />
        </div>
        <button class="btn-icon-secondary" @click="carregarEmpresas" :disabled="loading" title="Atualizar lista">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 10a7 7 0 1 1-2-4.9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M17 4v6h-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="btn-primary" @click="abrirModalCriar">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>Nova Empresa</span>
        </button>
      </div>

      <!-- Loading -->
      <div v-if="loading" class="loading-container">
        <div class="spinner-wrapper">
          <svg class="spinner" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="20" stroke="#00235C" stroke-width="4" stroke-linecap="round" stroke-dasharray="125" stroke-dashoffset="62.5"/>
          </svg>
        </div>
        <p class="loading-text">Carregando empresas...</p>
      </div>

      <!-- Lista de empresas -->
      <div v-else-if="empresasFiltradas.length > 0" class="empresas-grid">
        <div v-for="empresa in empresasFiltradas" :key="empresa.id" class="empresa-card">
          <div class="empresa-header">
            <div class="empresa-info">
              <h3 class="empresa-nome">{{ empresa.nome }}</h3>
              <span class="empresa-status" :class="{ 'status-ativo': empresa.ativo, 'status-inativo': !empresa.ativo }">
                {{ empresa.ativo ? 'Ativa' : 'Inativa' }}
              </span>
            </div>
          </div>

          <div class="empresa-body">
            <div class="empresa-detail" v-if="empresa.cnpj">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 2H2v12h12V2z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 6h6M5 9h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <span>{{ empresa.cnpj }}</span>
            </div>
            <div class="empresa-detail" v-if="empresa.email">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4l6 4 6-4M2 4v8h12V4H2z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ empresa.email }}</span>
            </div>
            <div class="empresa-detail" v-if="empresa.telefone">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 11v2a1 1 0 0 1-1 1A12 12 0 0 1 2 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-.5.9l-1 .6a9 9 0 0 0 4 4l.6-1a1 1 0 0 1 .9-.5h2a1 1 0 0 1 1 1z" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              <span>{{ empresa.telefone }}</span>
            </div>
            <div class="empresa-detail" v-if="empresa.produtos && empresa.produtos.length > 0">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="3" width="12" height="10" rx="1" stroke="currentColor" stroke-width="1.5"/>
                <path d="M6 7h4M6 10h2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <span>{{ empresa.produtos.length }} produto(s)</span>
            </div>
          </div>

          <div class="empresa-footer">
            <button class="btn-secondary-small" @click="gerenciarProdutos(empresa)">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="3" width="12" height="10" rx="1" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              Produtos
            </button>
            <button class="btn-secondary-small" @click="editarEmpresa(empresa)">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.3 1.3a1 1 0 0 1 1.4 0l2 2a1 1 0 0 1 0 1.4l-9 9L2 15l1.3-3.7 9-9z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Editar
            </button>
            <button class="btn-danger-small" @click="confirmarExclusao(empresa)">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4h12M5 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1M13 4v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4h10z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Excluir
            </button>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div v-else class="empty-state">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="8" y="12" width="48" height="40" rx="2" stroke="#9ca3af" stroke-width="2"/>
          <path d="M20 24h24M20 32h16" stroke="#9ca3af" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <h3>Nenhuma empresa encontrada</h3>
        <p>{{ filtro ? 'Tente buscar por outro termo' : 'Comece criando sua primeira empresa' }}</p>
      </div>
    </main>

    <!-- Modal Criar/Editar -->
    <ModalEmpresa
      :show="mostrarModalEmpresa"
      :empresa="empresaSelecionada"
      @close="fecharModalEmpresa"
      @salvo="handleEmpresaSalva"
    />

    <!-- Modal Produtos -->
    <ModalProdutos
      :show="mostrarModalProdutos"
      :empresa="empresaSelecionada"
      @close="fecharModalProdutos"
      @salvo="handleProdutosSalvos"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';
import ModalEmpresa from './ModalEmpresa.vue';
import ModalProdutos from './ModalProdutos.vue';
import api from '@/api/axios';

export default {
  name: 'EmpresasIndex',
  components: {
    PageHeader,
    ModalEmpresa,
    ModalProdutos
  },
  data() {
    return {
      empresas: [],
      filtro: '',
      loading: false,
      mostrarModalEmpresa: false,
      mostrarModalProdutos: false,
      empresaSelecionada: null
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    empresasFiltradas() {
      if (!this.filtro) return this.empresas;
      
      const termo = this.filtro.toLowerCase();
      return this.empresas.filter(e => 
        e.nome.toLowerCase().includes(termo) ||
        e.cnpj?.toLowerCase().includes(termo) ||
        e.email?.toLowerCase().includes(termo)
      );
    }
  },
  mounted() {
    // Verifica se é admin
    if (!this.user?.isAdminDNWAYS) {
      this.$swal({
        icon: 'error',
        title: 'Acesso negado',
        text: 'Apenas administradores podem acessar esta página.',
      }).then(() => {
        this.$router.push('/');
      });
      return;
    }
    
    this.carregarEmpresas();
  },
  methods: {
    async carregarEmpresas() {
      this.loading = true;
      
      try {
        const response = await api.get('/empresa', {
          withCredentials: true
        });
        
        this.empresas = response.data.map(empresa => ({
          id: empresa.id || empresa.Id,
          nome: empresa.nome || empresa.Nome,
          cnpj: empresa.cnpj || empresa.Cnpj,
          telefone: empresa.telefone || empresa.Telefone,
          email: empresa.email || empresa.Email,
          endereco: empresa.endereco || empresa.Endereco,
          ativo: empresa.ativo ?? empresa.Ativo ?? true,
          produtos: empresa.produtos || empresa.Produtos || []
        }));
        
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error('Erro ao carregar empresas:', error);
        
        if (error.response?.status === 401) {
          this.$router.push('/login');
        } else {
          this.$swal({
            icon: 'error',
            title: 'Erro ao carregar empresas',
            text: error.response?.data?.message || 'Ocorreu um erro ao buscar as empresas.',
          });
        }
      }
    },
    abrirModalCriar() {
      this.empresaSelecionada = null;
      this.mostrarModalEmpresa = true;
    },
    editarEmpresa(empresa) {
      this.empresaSelecionada = empresa;
      this.mostrarModalEmpresa = true;
    },
    fecharModalEmpresa() {
      this.mostrarModalEmpresa = false;
      this.empresaSelecionada = null;
    },
    handleEmpresaSalva() {
      this.fecharModalEmpresa();
      this.carregarEmpresas();
    },
    gerenciarProdutos(empresa) {
      this.empresaSelecionada = empresa;
      this.mostrarModalProdutos = true;
    },
    fecharModalProdutos() {
      this.mostrarModalProdutos = false;
      this.empresaSelecionada = null;
    },
    handleProdutosSalvos() {
      this.fecharModalProdutos();
      this.carregarEmpresas();
    },
    async confirmarExclusao(empresa) {
      const result = await this.$swal({
        title: 'Confirmar exclusão',
        text: `Deseja realmente excluir a empresa "${empresa.nome}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#ef4444',
      });
      
      if (result.isConfirmed) {
        await this.excluirEmpresa(empresa.id);
      }
    },
    async excluirEmpresa(id) {
      try {
        await api.delete(`/empresa/${id}`, {
          withCredentials: true
        });
        
        this.$swal({
          icon: 'success',
          title: 'Empresa excluída!',
          text: 'A empresa foi removida com sucesso.',
          timer: 2000,
          showConfirmButton: false
        });
        
        this.carregarEmpresas();
      } catch (error) {
        console.error('Erro ao excluir empresa:', error);
        
        this.$swal({
          icon: 'error',
          title: 'Erro ao excluir',
          text: error.response?.data?.message || error.response?.data?.Message || 'Não foi possível excluir a empresa.',
        });
      }
    },
    voltar() {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
}

.empresas-page {
  min-height: 100vh;
  background: #f9fafb;
}

.main-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
}

.action-bar {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.search-wrapper {
  flex: 1;
  min-width: 300px;
  position: relative;
}

.search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
}

.search-input {
  width: 100%;
  padding: 0.875rem 1rem 0.875rem 3rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 0.9375rem;
  color: #1f2937;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #00235C;
    box-shadow: 0 0 0 3px rgba(0, 35, 92, 0.1);
  }
}

.btn-icon-secondary {
  padding: 0.875rem;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: #f9fafb;
    border-color: #00235C;
    color: #00235C;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.btn-primary {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  background: linear-gradient(135deg, #00235C 0%, #001a45 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 0.9375rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0, 35, 92, 0.3);
  }
}

.loading-container {
  text-align: center;
  padding: 4rem 2rem;
}

.spinner-wrapper {
  display: inline-block;
  margin-bottom: 1rem;
}

.spinner {
  animation: rotate 1.5s linear infinite;
}

@keyframes rotate {
  to { transform: rotate(360deg); }
}

.loading-text {
  font-size: 1rem;
  color: #6b7280;
  font-weight: 500;
}

.empresas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.empresa-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 1.5rem;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }
}

.empresa-header {
  margin-bottom: 1rem;
}

.empresa-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.empresa-nome {
  font-size: 1.125rem;
  font-weight: 700;
  color: #00235C;
  flex: 1;
}

.empresa-status {
  padding: 0.375rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;

  &.status-ativo {
    background: #D1FAE5;
    color: #059669;
  }

  &.status-inativo {
    background: #FEE2E2;
    color: #DC2626;
  }
}

.empresa-body {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.empresa-detail {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #6b7280;

  svg {
    color: #9ca3af;
    flex-shrink: 0;
  }
}

.empresa-footer {
  display: flex;
  gap: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid #f3f4f6;
}

.btn-secondary-small,
.btn-danger-small {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 0.875rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;

  svg {
    width: 16px;
    height: 16px;
  }
}

.btn-secondary-small {
  color: #6b7280;

  &:hover {
    background: #f9fafb;
    border-color: #00235C;
    color: #00235C;
  }
}

.btn-danger-small {
  color: #ef4444;

  &:hover {
    background: #FEE2E2;
    border-color: #ef4444;
  }
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;

  svg {
    margin-bottom: 1.5rem;
  }

  h3 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #6b7280;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.9375rem;
    color: #9ca3af;
  }
}
</style>
